import { onCleanup } from "solid-js";

type DragNDropEvents = {
  onEnter?: (e: DragEvent) => void;
  onLeave?: (e: DragEvent) => void;
  onMove?: (e: DragEvent) => void;
  onDrop?: (e: DragEvent) => void;
};
export function dragNDropEvents$(el: HTMLElement, _events: DragNDropEvents) {
  const events = _events as () => DragNDropEvents;
  el.addEventListener("dragenter", onDragEnter);
  let registered = false;
  function onDragEnter(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (registered) {
      return;
    }
    registered = true;
    document.body.addEventListener("dragover", onDragOver);
    document.body.addEventListener("drop", onDrop);
    events()?.onEnter?.(e);
  }
  function onDragOver(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (el.contains(e.target as any)) {
      events()?.onMove?.(e);
      return;
    }
    onDragLeave(e);
  }
  function onDragLeave(e: DragEvent) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      events()?.onLeave?.(e);
    }
    registered = false;
    document.body.removeEventListener("dragover", onDragOver);
    document.body.removeEventListener("drop", onDrop);
  }
  function onDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (el.contains(e.target as any)) {
      events()?.onDrop?.(e);
    }
    onDragLeave(e);
  }

  onCleanup(() => {
    el.removeEventListener("dragenter", onDragEnter);
    onDragLeave(undefined);
  });
}
